import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b4ff90e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/happiness-psychology-course/read-data.png"
}, null, -1));
const _hoisted_3 = {
  class: "course"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "course-title"
}, "9大课程 向幸福学习幸福", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/class-schedule/202401.jpg"
}, null, -1));
import CourseBanner from "@/components/happiness-psychology-course/course-banner.vue";
import CourseSeactionHeader from "@/components/happiness-psychology-course/course-seaction-header.vue";
import PsychologyCourse from "@/components/index/psychology-course.vue";
import CourseTutorTeam from "@/components/happiness-psychology-course/course-tutor-team.vue";
import { receiveCourse } from "@/api/common";
import { useMeta } from "vue-meta";
import router from "@/router";
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useMeta({
      title: "幸福心理课",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "10 年精研课程 专注实战有用"
      }, {
        name: "kewords",
        content: "幸福心理课,专业心理学导师教学,全民幸福社"
      }]
    });
    function toTutorCollegeDetails() {
      router.push("/tutorcollege");
    }
    function toCourseDetails(courseId) {
      router.push({
        path: "/coursedetails",
        query: {
          courseId: courseId
        }
      });
    }
    const ruleFormRef = ref();
    const receiveCourseForm = reactive({
      name: "",
      mobile: ""
    });
    const receiveCourseFormRules = reactive({
      name: [{
        required: true,
        message: "请输入您的姓名",
        trigger: "blur"
      }, {
        min: 2,
        max: 10,
        message: "请输入 2~10 个汉字",
        trigger: "blur"
      }],
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        len: 11,
        message: "请输入正确的手机号码",
        trigger: "blur"
      }]
    });
    function clickReceiveCourse(formEl) {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          receiveCourse(receiveCourseForm.name, receiveCourseForm.mobile).then(() => {
            ElMessage.success("领取成功");
            receiveCourseForm.name = "";
            receiveCourseForm.mobile = "";
          });
        } else {
          return false;
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CourseBanner), _createVNode(CourseSeactionHeader, {
        title: "幸福心理学实战应用专家",
        "sub-title": "数万学员学心理信赖之选"
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(PsychologyCourse, {
        class: "course-info",
        onToCourseDetails: toCourseDetails
      }), _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        class: "receive-course",
        model: receiveCourseForm,
        rules: receiveCourseFormRules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "name",
          class: "receive-course-input"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: receiveCourseForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => receiveCourseForm.name = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入您的姓名",
            class: "receive-course-input-name"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "mobile",
          class: "receive-course-input"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: receiveCourseForm.mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => receiveCourseForm.mobile = $event),
            modelModifiers: {
              trim: true
            },
            type: "tel",
            placeholder: "请输入手机号码",
            class: "receive-course-input-phone"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("button", {
          type: "button",
          class: "receive-course-submit",
          onClick: _cache[2] || (_cache[2] = $event => clickReceiveCourse(ruleFormRef.value))
        }, " 免费领取体验课程 ")]),
        _: 1
      }, 8, ["model", "rules"])]), _createVNode(CourseSeactionHeader, {
        title: "精英导师团队",
        "sub-title": "层层筛选考核"
      }), _createVNode(CourseTutorTeam, {
        onToTutorCollegeDetails: toTutorCollegeDetails
      }), _createVNode(CourseSeactionHeader, {
        title: "幸福心理课",
        "sub-title": "本月课表"
      }), _hoisted_5]);
    };
  }
});